import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import "./BatchShipments.scss";
import { Link } from "react-router-dom";
import dhlLogo from "../../../assets/images/company_logos/dhl-logo.png";
import fedexLogo from "../../../assets/images/company_logos/fedex-logo.png";
import tntLogo from "../../../assets/images/company_logos/tnt-logo.png";
import upsLogo from "../../../assets/images/company_logos/ups-logo.png";
import uspsLogo from "../../../assets/images/company_logos/usps-logo.png";
import shipstationGear from "../../../assets/images/shipstation/shipstation-gear.png";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetBatchShipmentsDTO from "../../../models/DTO/IGetBatchShipmentsDTO";
import IOnGetBatchShipmentsDTO from "../../../models/DTO/IOnGetBatchShipmentsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IOwTableCols from "../../../models/IOwTableCols";
import IShipment_Batch from "../../../models/IShipment_Batch";
import IShipment_Batch_Shipment from "../../../models/IShipment_Batch_Shipment";
import IShipmentUI from "../../../models/IShipmentUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import SocketService from "../../../services/SocketService";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";
import BetaBadge from "../../shared/BetaBadge/BetaBadge";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import ChevronToggle from "../../shared/ChevronToggle/ChevronToggle";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import ShipmentTracking from "../Shipments/ShipmentTracking/ShipmentTracking";
import { Socket } from "socket.io-client";
import {SearchSection} from "../../shared/SearchSection/SearchSection";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    crumbs: IBreadcrumbs[];
    batchShipments: any[];
    columns: IOwTableCols[];
    detailViewColumns: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
    offset: number;
    limit: number;
    totalBatchShipments: number;
    shipmentBatchToken: string;
    order_batch?: string;
    shipment_batch?: string;
    isVisible: boolean;
};

class BatchShipments extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            batchShipments: [],
            columns: [
                {
                    hasChevron: true,
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderBatchActionsCol,
                    renderFnEmitsRow: true,
                    className: "w-2r",
                },
                {
                    title: "batch_no",
                    valueProp: "batch_no",
                    className: "w-2r",
                },
                {
                    title: "order_batch_no",
                    valueProp: "Order_Batch",
                    valueSubProp: "batch_no",
                    className: "w-2r",
                },
                {
                    title: "total_shipments",
                    valueProp: "total_shipments",
                    className: "w-2r",
                },
            ],
            detailViewColumns: [
                {
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderShipmentAction,
                    renderFnEmitsRow: true,
                },
                {
                    title: "order",
                    valueProp: "",
                    renderFn: this.renderShipmentOrder,
                    renderFnEmitsRow: true,
                    className: "w-10r",
                },
                {
                    title: "ship_date",
                    valueProp: "",
                    renderFn: this.renderShipDate,
                    renderFnEmitsRow: true,
                },
                {
                    title: "carrier",
                    valueProp: "",
                    renderFn: this.renderCarrier,
                    renderFnEmitsRow: true,
                },
                {
                    title: "status",
                    valueProp: "",
                    renderFn: this.renderShipmentStatus,
                    renderFnEmitsRow: true,
                },
                {
                    title: "tracking",
                    valueProp: "",
                    renderFn: this.renderTracking,
                    renderFnEmitsRow: true,
                },
            ],
            isDataFetching: false,
            isInitialData: true,
            crumbs: [
                {
                    title: "shipments",
                    url: "/shipments",
                },
                {
                    title: "batch",
                    url: "/batch",
                },
            ],
            offset: 0,
            limit: 10,
            totalBatchShipments: 0,
            shipmentBatchToken: "",
            isVisible: true,
        };

        document.title = `Orderwerks >> Shipments >> Batch`;
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.ShipmentOnGetBatchShipments, this.onGetBatchShipments);

        this.getBatchShipments();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnGetBatchShipments, this.onGetBatchShipments);
    }

    getLabelUrl = (row: IShipment_Batch, withPackingList: boolean): string => {
        const endpointUrl = SocketService.getApiEndpointURl();

        let url = `${endpointUrl}/shipstation/batch/labelpack/${row.batch_no}?token=${this.state.shipmentBatchToken}`;

        if (!withPackingList) {
            url += `&inclPackingList=false`;
        }

        return url;
    };

    renderBatchActionsCol = (row: IShipment_Batch) => {
        return (
            <div className={"d-flex flex-column"}>
                <a className={"pointer"} href={this.getLabelUrl(row, false)} target={"_blank"} rel="noreferrer">
                    <OwTranslate defaultMessage={"labels"} id={"labels"} />
                </a>

                <a className={"pointer"} href={this.getLabelUrl(row, true)} target={"_blank"} rel="noreferrer">
                    <OwTranslate defaultMessage={"labels_with_packing_lists"} id={"labels_with_packing_lists"} />
                </a>
            </div>
        );
    };

    renderShipmentAction = (row: IShipment_Batch_Shipment) => {
        if (row.Order) {
            return (
                <Link to={`/shipments?order=${row.Order.name}`}>
                    <OwLabel className={"pointer"} title={"view"} noBottomMargin={true} />
                </Link>
            );
        }
    };

    renderTotalErrored = (totalErrored: number) => {
        if (totalErrored) {
            return totalErrored;
        } else {
            return "--";
        }
    };

    renderShipmentOrder = (row: IShipment_Batch_Shipment) => {
        if (row.Order) {
            return <Link to={`/orders/${row.Order.guid}/entry`}>{row.Order.name}</Link>;
        }
    };

    renderShipDate = (row: IShipment_Batch_Shipment) => {
        let shipment_date;

        if (!_.isNil(row.shipment_date)) {
            shipment_date = UserService.parseDate(row.shipment_date);
        }

        return <div className={row.is_voided ? " text-muted text-strikethrough" : ""}>{shipment_date}</div>;
    };

    getShippingCarrierNameAndLogo = (row: IShipment_Batch_Shipment): { shipping_carrier_name: string; shipping_carrier_logo: any } => {
        let shipping_carrier_name = _.get(row.Shipping_Carrier, "name", "");

        if (!_.isNil(row.shipstation_carrierCode)) {
            shipping_carrier_name = row.shipstation_carrierCode;
        }

        let shipping_carrier_logo: any = null;

        switch (shipping_carrier_name) {
            case "FEDEX":
            case "fedex":
                shipping_carrier_name = "FedEx";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={fedexLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;

            case "UPS":
            case "ups":
                shipping_carrier_name = "UPS";
                shipping_carrier_logo = <img src={upsLogo} height={20} title={shipping_carrier_name} />;
                break;

            case "USPS":
            case "usps":
                shipping_carrier_name = "USPS";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={uspsLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;

            case "DHL":
            case "dhl":
                shipping_carrier_name = "DHL";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={dhlLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;

            case "TNT":
            case "tnt":
                shipping_carrier_name = "TNT";
                shipping_carrier_logo = (
                    <img
                        style={{
                            backgroundColor: "white",
                            padding: "3px",
                            borderRadius: "3px",
                        }}
                        src={tntLogo}
                        height={20}
                        title={shipping_carrier_name}
                    />
                );
                break;
        }

        return { shipping_carrier_name, shipping_carrier_logo };
    };

    renderCarrier = (row: IShipment_Batch_Shipment) => {
        const shippingCarrierDetails = this.getShippingCarrierNameAndLogo(row);

        let shipping_carrier_name = shippingCarrierDetails.shipping_carrier_name;
        const shipping_carrier_logo = shippingCarrierDetails.shipping_carrier_logo;

        const shipstation_labelData = _.get(row, "shipstation_labelData", undefined);

        let shipstation_logo: any = null;

        if (!_.isNil(shipstation_labelData)) {
            shipping_carrier_name = _.get(row, "shipstation_carrierCode", "");
            shipstation_logo = <img src={shipstationGear} height={20} />;
        }

        return (
            <div>
                {shipping_carrier_logo || shipping_carrier_name} {shipstation_logo}
            </div>
        );
    };

    renderShipmentStatus = (row: IShipment_Batch_Shipment) => {
        if (row.is_voided) {
            return <BetaBadge title={"voided"} />;
        } else {
            let shipment_status_name = _.get(row.Shipment_Status, "name", "");

            shipment_status_name = _.startCase(_.toLower(shipment_status_name));

            return shipment_status_name;
        }
    };

    renderTracking = (row: IShipment_Batch_Shipment) => {
        const { shipping_carrier_name, shipping_carrier_logo } = this.getShippingCarrierNameAndLogo(row);

        return <ShipmentTracking tracking={row.tracking} service={shipping_carrier_name} isVoided={row.is_voided} />;
    };

    getBatchShipments = () => {
        const payload: IGetBatchShipmentsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            limit: this.state.limit,
            offset: this.state.offset,
        };

        const queryString = this.buildQueryString();

        if (queryString.length) {
            payload.queryString = queryString;
        }

        this.props.socket.emit(EndpointsEnum.ShipmentGetBatchShipments, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetBatchShipments = (data: IOnGetBatchShipmentsDTO) => {
        this.setState({
            batchShipments: data.batchShipments,
            totalBatchShipments: data.totalBatchShipments,
            shipmentBatchToken: data.shipmentBatchToken,
            isDataFetching: false,
            isInitialData: false,
        });
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getBatchShipments();
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    search = () => {
        this.setState(
            {
                limit: 25,
                offset: 0,
            },
            () => {
                this.getBatchShipments();
            }
        );
    };

    resetSearch = () => {
        this.setState(
            {
                order_batch: "",
                shipment_batch: "",
            },
            () => {
                this.getBatchShipments();
            }
        );
    };

    toggleVisible = () => {
        this.setState({
            isVisible: !this.state.isVisible,
        });
    };

    enterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.search();
        }
    };

    buildQueryString = (): string => {
        const query: string[] = [];

        if (!_.isNil(this.state.order_batch) && this.state.order_batch.length) {
            query.push(`order_batch=${this.state.order_batch}`);
        }

        if (!_.isNil(this.state.shipment_batch) && this.state.shipment_batch.length) {
            query.push(`shipment_batch=${this.state.shipment_batch}`);
        }

        let queryString = "";

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        return queryString;
    };

    render() {
        let cardClass = "dark-card text-white bg-secondary";

        if (UIService.isMainViewLight()) {
            cardClass = "";
        }

        return (
            <div className="BatchShipments">
                <Breadcrumbs crumbs={this.state.crumbs} />

                <div className="row mt-2">
                    <div className={"col-12 d-flex align-items-center"}>
                        <OwTitle title={"batch_shipments"} leftIconName={"fad fa-boxes"} />
                    </div>
                </div>

                <div className={"row mt-2 mb-3"}>
                    <div className={"col-12 " + (this.state.isVisible ? "" : "d-none")}>
                        <SearchSection>
                            <div className={"row d-flex align-items-end"}>
                                <div className={"col-12 col-md-2 mb-4 mb-md-0"}>
                                    <OwLabel title={"shipment_batch"} />
                                    <div>
                                        <OwInputWrapper
                                            name={"shipment_batch"}
                                            fn={this.handleChange}
                                            value={this.state.shipment_batch}
                                            onKeyDownFn={this.enterSearch}
                                        />
                                    </div>
                                </div>

                                <div className={"col-12 col-md-2 mb-4 mb-md-0"}>
                                    <OwLabel title={"order_batch"} />
                                    <div>
                                        <OwInputWrapper
                                            name={"order_batch"}
                                            fn={this.handleChange}
                                            value={this.state.order_batch}
                                            onKeyDownFn={this.enterSearch}
                                        />
                                    </div>
                                </div>

                                <div className={"col"}>
                                    <OwButton
                                        title={"search"}
                                        fn={this.search}
                                        disabled={this.state.isDataFetching}
                                        disableOnActive={true}
                                    />
                                    <OwButton
                                        title={"reset"}
                                        fn={this.resetSearch}
                                        className={"btn-danger ms-2"}
                                        disabled={this.state.isDataFetching}
                                        disableOnActive={true}
                                    />
                                </div>
                            </div>
                        </SearchSection>
                    </div>
                </div>

                <div className={"table-responsive"}>
                    <OwTable
                        columns={this.state.columns}
                        detailViewDataSet={this.state.batchShipments}
                        detailViewDataSetProp={"Shipments"}
                        isDetailViewTable={true}
                        tableConfig={{ hasDetailView: true, tableStriped: true }}
                        detailViewColumns={this.state.detailViewColumns}
                        dataSet={this.state.batchShipments}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                    />
                </div>

                <div>
                    <PaginationBar
                        offset={this.state.offset}
                        limit={this.state.limit}
                        totalRecords={this.state.totalBatchShipments}
                        onPaginationChanged={this.paginationChanged}
                    />
                </div>
            </div>
        );
    }
}

export default BatchShipments;
